import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import DateUtils from '../../../../utils/date/DateUtils';
import './FormattedDate.css';
var defaultProps = {
  iso: true,
  inputFormat: null,
  timezone: null
};
export default function FormattedDate(_ref) {
  var date = _ref.date,
    iso = _ref.iso,
    inputFormat = _ref.inputFormat,
    outputFormat = _ref.outputFormat,
    timezone = _ref.timezone;
  if (_isEmpty(date)) {
    return null;
  }
  var parsedDate = iso ? DateUtils.parseISO(date, timezone) : DateUtils.parse(date, inputFormat, {
    timezone: timezone
  });
  var formattedDate = DateUtils.format(parsedDate, outputFormat);
  return /*#__PURE__*/React.createElement("span", {
    className: "date-container"
  }, formattedDate);
}
FormattedDate.defaultProps = defaultProps;